<template>
  <v-app-bar app light color="white" class="noprint elevation-hb">
    <router-link to="/">
      <img class="mx-3" height="32px" src="@/assets/waplogohubble-horizontal.png" />
    </router-link>
    <div class="flex-grow-1"></div>
    <h3>{{ user.user }}</h3>

    <v-menu transition="slide-y-transition" bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon dark>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="dialog = true" v-on="on"><v-icon dark>mdi-account</v-icon></v-btn>
              </template>
              <span>Trocar Senha</span>
            </v-tooltip>
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn icon @click.prevent="logout" v-on="on"><v-icon dark>mdi-logout</v-icon></v-btn>
              </template>
              <span>Sair</span>
            </v-tooltip>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <TheDialog width="400px" title="Trocar Senha" v-model="dialog" icon="mdi-account-key-outline">
      <template>
        <v-form ref="form">
          <b>Nova senha</b>
          <v-text-field
            v-model="userPassword.appkey"
            :counter="100"
            required
            hide-details
            :error="error"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            class="mb-5"
          ></v-text-field>
          <b>Confirmar nova senha</b>
          <v-text-field
            v-model="userPassword.passwordConfirm"
            :counter="100"
            :error="error"
            required
            hide-details
            type="password"
            class="mb-5"
          ></v-text-field>
        </v-form>
      </template>

      <template v-slot:actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary " dark depressed @click="updatePassword()">Alterar</v-btn>
      </template>
    </TheDialog>
  </v-app-bar>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { baseApiUrl, showError, userPayload } from '@/global'
import TheDialog from '@/components/TheDialog'

export default {
  computed: mapState(['logged', 'user']),
  components: { TheDialog },
  data: () => ({
    messages: [],
    dialog: false,
    userPassword: {},
    rules: {},
    error: false,
    showPassword: false,
  }),
  methods: {
    toggleMenu() {
      this.$store.commit('toggleMenu')
    },
    logout() {
      localStorage.removeItem(userPayload)
      this.$store.commit('setUser', null)
      this.$router.push({ name: 'login' })
    },
    getUnreadMessages() {
      const url = `${baseApiUrl}/messages/unread`
      axios
        .get(url)
        .then((res) => {
          this.messages = res.data
        })
        .catch(showError)
    },
    updatePassword() {
      this.error = false
      if (!this.userPassword.appkey || !this.userPassword.passwordConfirm) {
        this.error = true
        return false
      }
      if (this.userPassword.appkey !== this.userPassword.passwordConfirm) {
        this.error = true
        return false
      }
      delete this.userPassword.passwordConfirm

      this.user.appkey = this.userPassword.appkey
      const url = `${baseApiUrl}/user/${this.user.idUser}`
      axios
        .put(url, this.user)
        .then(() => {
          this.userPassword = {}
          delete this.user.appkey
          this.dialog = false
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
  },
  mounted() {
    this.getUnreadMessages()
  },
}
</script>

<style>
.hubble {
  font-family: 'ZCOOL KuaiLe', cursive !important;
  font-size: 150% !important;
}

.mt-message {
  border-top: 1px solid #cecece;
}
.mb-message {
  border-bottom: 1px solid #cecece;
}
</style>
